import type { V1MotiActions } from '@/lib/api/lib/models/V1MotiActions'
import { useEventStream } from '@/hooks/useEventStream'

const RECONNECT_MS = 3000

/**
 * Listens to one motivation stream (/motivation/listen/<action>) and keeps
 * reconnecting after errors. onMessage may change between renders without
 * reconnecting.
 */
export function useMotivationStream<T>(
    action: V1MotiActions,
    onMessage: (data: T) => void,
    { onOpen }: { onOpen?: () => void } = {}
) {
    useEventStream<T>(
        `${import.meta.env.VITE_API_HOST}/api/v1/motivation/listen/${action}`,
        {
            onMessage,
            onOpen,
            retryDelay: () => RECONNECT_MS
        }
    )
}
